export enum ComplianceRenewalFrequencyModel {
  Never = 0, // never
  ThreeMonths = 3, // 3 months
  SixMonths = 6, // 6 months
  OneYear = 12, // 12 months
  TwoYears = 24, // 24 months
  ThreeYears = 36 // 36 months
}
